module.exports = __webpack_public_path__ + "img/A2.f8031df6.svg";